/*=========================================================================================
  File Name: main.js
  Description: main vue(js) file
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import Vue from "vue";
import App from "./App.vue";

// Vuesax Component Framework
import Vuesax from "vuesax";
import "material-icons/iconfont/material-icons.css"; //Material Icons
import "vuesax/dist/vuesax.css"; // Vuesax
Vue.use(Vuesax);

// axios
import axios from "axios";
Vue.prototype.$http = axios;

// Theme Configurations
import "../themeConfig.js";

// Algolia - Instant Search
import InstantSearch from "vue-instantsearch";
Vue.use(InstantSearch);

// Auth Plugin
import AuthPlugin from "./plugins/auth";
Vue.use(AuthPlugin);

// ACL
import acl from "./acl/acl";

// Globally Registered Components
import "./globalComponents.js";

// Styles: SCSS
import "./assets/scss/main.scss";
import "./assets/scss/main-rtl.scss";

// Tailwind
import "@/assets/css/main.css";

// Vue Router
import router from "./router";

// Vuex Store
import store from "./store/store";

// i18n
import i18n from "./i18n/i18n";

// Vuesax Admin Filters
import "./filters/filters";

// Clipboard
import VueClipboard from "vue-clipboard2";
Vue.use(VueClipboard);

// Tour
import VueTour from "vue-tour";
Vue.use(VueTour);
require("vue-tour/dist/vue-tour.css");

// VeeValidate
import VeeValidate from "vee-validate";
///Vue.use(VeeValidate);
Vue.use(VeeValidate, { fieldsBagName: "formFields" });

// Google Maps
import * as VueGoogleMaps from "vue2-google-maps";
Vue.use(VueGoogleMaps, {
  load: {
    // Add your API key here
    key: "API_KEY",
    libraries: "places", // This is required if you use the Auto complete plug-in
  },
});

// Vuejs - Vue wrapper for hammerjs
import { VueHammer } from "vue2-hammer";
Vue.use(VueHammer);

// PrismJS
import "prismjs";
import "prismjs/themes/prism-tomorrow.css";

// Feather font icon
require("./assets/css/iconfont.css");
require("./assets/css/iransans.css");
// Vue select css
// Note: In latest version you have to add it separately
// import 'vue-select/dist/vue-select.css';

///Sweet Alert
import VueSweetalert2 from "vue-sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
Vue.use(VueSweetalert2);

////PersianDateTimePicker
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
Vue.component("date-picker", VuePersianDatetimePicker);
////truncate
var VueTruncate = require("vue-truncate-filter");
Vue.use(VueTruncate);
///filter input
import VueTheMask from "vue-the-mask";
Vue.use(VueTheMask);
////
import VueBarcode from "@xkeshi/vue-barcode";
Vue.component(VueBarcode.name, VueBarcode);
// Ajax Plugin
import AjaxPlugin from "./plugins/ajax";
Vue.use(AjaxPlugin);

Vue.config.productionTip = false;

// permissionCotnrol
import tabHasPermission from "./plugins/tabPermission.js";
Vue.prototype.$tabHasPermission = tabHasPermission;

// directives
import trimSpace from "@/directives/trimSpace.js";
Vue.directive("trim-space", trimSpace);

new Vue({
  router,
  store,
  i18n,
  acl,
  render: (h) => h(App),
}).$mount("#app");
